import { ReactNode } from "react";

interface SettingsRowProps {
  title: string;
  description?: ReactNode;
  // Optional inline value shown beside the title (e.g. a dataset id).
  value?: ReactNode;
  // The action control (button) rendered on the right.
  children: ReactNode;
}

/**
 * One labeled action row on an entity's Settings page: a title with optional
 * description / value on the left and a right-aligned action control.
 */
export const SettingsRow = ({ title, description, value, children }: SettingsRowProps) => (
  <div className="flex items-center justify-between gap-4 px-4 py-3">
    <div className="min-w-0 flex-1">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-foreground">{title}</span>
        {value != null && (
          <span className="truncate font-mono text-xs text-muted-foreground">{value}</span>
        )}
      </div>
      {description && <p className="mt-0.5 text-xs text-muted-foreground">{description}</p>}
    </div>
    <div className="shrink-0">{children}</div>
  </div>
);
